<template>
  <div>
    <p class="head-text">{{headInfo}}</p>
    <ul class="career-box">
      <li class="career-list" v-for="(item,index) in content">
      <a @click="getCareer(item[0].career)">{{item[0].career}}（{{item[0].count}}）</a>
      <a @click="getCareer(item[1].career)">{{item[1].career}}（{{item[1].count}}）</a>
      </li>
    </ul>
  </div>
</template>
<!--多答案-->
<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
export default {
  props:{
    content: Array,
    mode: String
  },
  data(){
    return{
      listCareer:[],
      arrHeadInfo: ['点开下面的职业群，选择你要从事的职业方向','点开下面的职业群，查看职业与你的匹配度']
    }
  },
	computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),    
		headInfo() {
			let infoIndex = this.mode=='explore'?0:1
			return this.arrHeadInfo[infoIndex]
		},
	},  
  methods:{
    // 对获取的职业群数据分组
    groupBy(arr,key,child){
      this.listCareer=[]
      arr.reduce((t, v, i) => {
        // 查询数组中是否已有这个类别
        let findIndex = [].concat(this.listCareer).findIndex(e => e[key] === v.category2)
        // 已有类别,加入到子数组中
        if ( findIndex > -1) {
          this.listCareer[findIndex][child] = this.listCareer[findIndex][child].concat([{careerName: v.careerName, iTotalScore: v.iTotalScore,hollandPreThree:v.hollandPreThree,selected:false}])
        } else {
        // 没有此类别加一条新数据到数组
          this.listCareer.length += 1
          this.listCareer[this.listCareer.length - 1] = {}
          this.listCareer[this.listCareer.length - 1][key] = v[key]
          this.listCareer[this.listCareer.length - 1]['category1'] = v.category1
          this.listCareer[this.listCareer.length - 1][child] = [].concat([{careerName: v.careerName, iTotalScore: v.iTotalScore,hollandPreThree:v.hollandPreThree,selected:false}])
        }
        return this.listCareer
      },[])
    },
    // 获取职业群下的职业
    getCareer(category){
      const options = {
        method: 'post',
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          category1: category,
					openId: this.shengyaUser.openid
        }),
        url: '/cob/cosCareerMatch.do'
      };
      axios(options)
      .then( (res) => {
        if(res.data.result.success){
          let consult = res.data.data
          let listCareer =consult.cosCareer.listCareer
          this.groupBy(listCareer, 'category2','listCareer')
          this.$emit("listenToChildEvent",this.listCareer)
        }
        else
          this.$store.commit('showMessage', {
            message: res.data.result.message,
            type: 'error'
          })
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
  }
}
</script>
<style lang="stylus" scoped>
  .head-text
    text-align:center
  .career-box
    overflow-y:auto
    .career-list
      overflow:hidden
      max-width:12rem
      a
        display:block
        width:43%
        float:left
        color:#ffffff
        margin:0.1rem
        padding:0.2rem 0.1rem
        border-radius:6px
        height:0.6rem
        display: flex;
        display:-webkit-flex;
        justify-content: left;/*水平居左*/
        align-items: center;/*垂直居中*/
        -webkit-align-items:center;
    .career-list:nth-child(odd)
      a
        background-color:#00B3DE
    .career-list:nth-child(even)
      a
        background-color:#787878

</style>
